import React from 'react';
import './Styles.css';

function Welcome() {
  return (
    <>
    <div className="welcome-parent">
        <span className='image01'></span>
        <span className='image02'></span>   
        <span className="content">
            <h1> Welcome </h1>
            <h1> Welcome </h1>
        </span>     
    </div>
    </>
  )
}

export default Welcome
